import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Popper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { red } from '@mui/material/colors';
import _, {
  debounce,
  isEmpty,
  isEqual,
  isNull,
  isUndefined,
  reject,
} from 'lodash';
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useReducer,
  useState,
  useRef,
} from 'react';
import {
  DesktopDatePicker,
  DesktopDateTimePicker,
  LocalizationProvider,
  TimePicker,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import InputMask from 'react-input-mask';
import axios from 'axios';
import dayjs from 'dayjs';
import { ehrAPIBaseService } from '../../../../http-common';
import jwtDecode from 'jwt-decode';
import { pl } from 'date-fns/locale';
import { useMainFrameState } from '../../../MainUIFrame/MainFrame';
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';
import { useDispatch, useSelector } from 'react-redux';
import { getZipCodes } from '../../../../config/common';
import NoOptions from '../../../form/noOptions';
import { quickAddData } from '../../../../redux/features/quickAddDataSlice';

export const TextFieldWithTopLabelComponent = forwardRef((props, ref) => {
  const {
    label,
    width = '100%',
    name,
    value = '',
    onChange,
    type = 'text',
    validation,
    disabled = false,
    rows = 4,
    inputComponent = null,
    mask = null,
    defaultValue = '',
    maxLength = null,
    inputVariant = null,
    multiline = false,
    emailRequired,
  } = props;

  const [errorText, setErrorText] = useState('');

  useImperativeHandle(ref, () => ({
    onValidate() {
      let isValid = true;

      if (name === 'faxNumber') {
        if (value.length !== 10) {
          isValid = false;
          setErrorText(`${label} must be 10 digits long`);
        } else {
          setErrorText('');
          isValid = true;
        }
      } else if (name === 'ssn') {
        if (
          value?.length === validation?.min ||
          value?.length === validation?.max
        ) {
          setErrorText('');
          isValid = true;
        } else {
          setErrorText(
            `${label} must be either a 9-digit or the last 4 digits of SSN`
          );
          isValid = false;
        }

        if (isValid === false && validation?.required === false && !value) {
          setErrorText('');
          isValid = true;
        }
      } else {
        if (!isUndefined(validation?.min) && !isUndefined(validation?.max)) {
          if (validation?.min === validation?.max) {
            if (value?.length !== validation?.max) {
              setErrorText(
                `${label} must be  ${validation?.min} characters long`
              );
              isValid = false;
            } else {
              setErrorText('');
            }
          } else if (
            value?.length >= validation?.min &&
            value?.length <= validation?.max
          ) {
            setErrorText('');
            isValid = true;
          } else {
            setErrorText(
              `${label} must be between ${validation?.min} and ${validation?.max} characters`
            );
            isValid = false;
          }
          if (isValid === false && validation?.required === false && !value) {
            setErrorText('');
            isValid = true;
          }
        } else {
          if (validation?.required) {
            if (value?.length === 0) {
              setErrorText(`${label} field cannot be empty`);
              isValid = false;
            } else {
              setErrorText('');
              isValid = true;
            }
          }
        }
      }

      if (inputVariant === 'zipcode') {
        // axios
        //   .get(`https://api.zippopotam.us/us/${value}`)
        //   .then((response) => {
        //     if (response?.data?.places?.length > 0) {
        //       setErrorText("");
        //       isValid = true;
        //     } else {
        //       setErrorText("Invalid Zipcode");
        //       isValid = false;
        //     }
        //   })
        //   .catch((error) => {
        //     if (error?.response?.status === 404) {
        //       setErrorText("Invalid Zipcode");
        //       isValid = false;
        //       return;
        //     } else {
        //       setErrorText("Cannot verify zipcode as server is down");
        //       isValid = true;
        //     }
        //   });
        // try {
        //   const response = await axios.get(
        //     `https://api.zippopotam.us/us/${value}`
        //   );
        //   if (response?.data?.places?.length > 0) {
        //     setErrorText("");
        //     isValid = true;
        //   } else {
        //     setErrorText("Invalid Zipcode");
        //     isValid = false;
        //   }
        // } catch (error) {
        //   setErrorText("Cannot verify zipcode as server is down");
        //   isValid = false;
        // } finally {
        // }
      }

      if (isValid) {
        if (
          validation?.pattern &&
          ((validation?.required && value) || (!validation?.required && value))
        ) {
          if (!value?.match(validation?.pattern)) {
            setErrorText(`${label} is in invalid format`);
            isValid = false;
          } else {
            setErrorText('');
            isValid = true;
          }
        }
      }

      console.log(`${label} validation`, { name, value, valid: isValid });
      return { name, value, valid: isValid };
    },
  }));

  const handleKeyDown = event => {
    const key = event.key;
    // Prevent input of 'e' key when type is number
    if (type.toLowerCase() === 'number') {
      if (key === 'e' || key === 'E') {
        event.preventDefault();
      }
    }
  };

  useEffect(() => {
    if (name === 'email' && emailRequired === false) {
      setErrorText('');
    }
  }, [emailRequired, name]);

  const unmasked = (
    <Box sx={{ width: `${width}` }}>
      <Typography sx={{ fontSize: 14 }}>
        {/* {`${label}: ${validation?.required ? '*' : ''}`} */}
        <Typography sx={{ fontSize: 14 }}>
          {!_.isEmpty(label) && `${label} `}
          {validation?.required && <span style={{ color: red[500] }}>*</span>}
        </Typography>{' '}
      </Typography>
      <TextField
        disabled={disabled}
        type={type}
        onChange={event => onChange(event)}
        name={name}
        value={value}
        fullWidth
        multiline={multiline}
        defaultValue={defaultValue}
        rows={rows}
        sx={{
          width: `${width}`,
          '& .MuiOutlinedInput-root': {
            '& > fieldset': {
              borderColor: 'textFieldColor',
              borderWidth: 2,
            },
          },
          '.MuiFormHelperText-root': {
            fontSize: '14px',
          },
        }}
        onKeyDown={handleKeyDown}
        inputProps={{ maxLength: maxLength }}
        size="small"
        error={_.isEmpty(errorText) ? false : true}
        helperText={errorText}
        InputProps={{
          inputComponent: inputComponent,
        }}
      />
    </Box>
  );

  const masked = (
    <Box sx={{ width: `${width}` }}>
      <Typography sx={{ fontSize: 14 }}>
        {`${label} `}
        {validation?.required ? <span style={{ color: red[500] }}>*</span> : ''}
      </Typography>
      <InputMask
        type="number"
        disabled={disabled}
        name={name}
        mask={mask}
        value={value}
        onChange={event => {
          // let value = event?.target?.value;
          // value = value.replace(/[^\d]/g, '');
          // event.target.value = value;
          onChange(event);
        }}
        onBlur={event => {
          let value = event?.target?.value;
          value = value.replace(/[^\d]/g, '');
          event.target.value = value;
          onChange(event);
        }}
      >
        {inputProps => (
          <Tooltip
            disableInteractive
            title={
              name === 'ssn' && 'Enter last 4 digits of SSN or 9-digits SSN'
            }
            arrow
          >
            <TextField
              {...inputProps}
              type={type}
              fullWidth
              multiline={multiline}
              rows={rows}
              sx={{
                width: `${width}`,
                '& .MuiOutlinedInput-root': {
                  '& > fieldset': {
                    borderColor: 'textFieldColor',
                    borderWidth: 2,
                  },
                },
                '.MuiFormHelperText-root': {
                  fontSize: '14px',
                },
              }}
              size="small"
              error={_.isEmpty(errorText) ? false : true}
              helperText={errorText}
              InputProps={{
                inputComponent: inputComponent,
              }}
            />
          </Tooltip>
        )}
      </InputMask>
    </Box>
  );

  return mask === null ? unmasked : masked;

  // return (
  //   <Box sx={{ width: `${width}` }}>
  //     <Typography sx={{ fontSize: 14 }}>
  //       {`${label}: ${validation?.required ? "*" : ""}`}
  //     </Typography>
  //     <TextField
  //       disabled={disabled}
  //       type={type}
  //       onChange={(event) => onChange(event)}
  //       name={name}
  //       value={value}
  //       fullWidth
  //       multiline
  //       rows={rows}
  //       sx={{ width: `${width}` }}
  //       size="small"
  //       error={_.isEmpty(errorText) ? false : true}
  //       helperText={errorText}
  //       InputProps={{
  //         inputComponent: inputComponent,
  //       }}
  //     />
  //   </Box>
  // );
});

export const SelectWithTopLabelComponent = forwardRef(
  (
    {
      label,
      width = '100%',
      value,
      defaultValue = '',
      onChange,
      name,
      optionsList,
      disabled = false,
      validation = {
        required: false,
      },
      checkBoxSelection = false,
      multiple = false,
      maxHeight = '32vh',
      enableTooltip,
      from,
    } = {},
    ref
  ) => {
    /**
     * @param @optionsList {object array} must be in the form '[{code: code, display: display}]'
     */

    const [errorText, setErrorText] = useState('');

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;
        let cErrorText = '';

        if (validation?.required) {
          if (multiple) {
            cErrorText = '';
            if (isEmpty(value)) {
              cErrorText = `${label} field cannot be empty`;
              isValid = false;
            }
          } else {
            cErrorText = '';
            // if the value is number type then its convert first into string
            let strValue = typeof value === 'number' ? String(value) : value;
            if (isEmpty(strValue)) {
              cErrorText = ` ${label} field cannot be empty`;
              isValid = false;
            }
          }

          setErrorText(cErrorText);
        } else {
          setErrorText('');
        }

        return { name, value, valid: isValid };
      },
    }));

    const [openToolTip, setOpenToolTip] = useState(false);
    const [focusOut, setFocusOut] = useState(false);

    const renderSelectedItems = selected => {
      if (checkBoxSelection) {
        const selectedItems = optionsList
          .filter(item => selected?.includes(item?.code))
          .map(item => item?.display);
        return selectedItems.join(', ');
      }
      return optionsList?.find(item => item?.code === selected)?.display;
    };
    return (
      <>
        <FormControl
          sx={{
            width: `${width}`,
            '.MuiFormHelperText-root': {
              fontSize: '14px',
            },
          }}
        >
          <Typography sx={{ fontSize: 14 }}>
            {!_.isEmpty(label) && `${label} `}
            {validation?.required && <span style={{ color: red[500] }}>*</span>}
          </Typography>
          <Tooltip
            title={
              (enableTooltip == 'enable' &&
                from == 'practCalendar' &&
                value?.reduce((acc, word) => acc + word?.length, 0) > 46 &&
                renderSelectedItems(value)) ||
              (enableTooltip == 'enable' &&
                from == 'practLoc' &&
                value?.reduce((acc, word) => acc + word?.length, 0) > 18 &&
                renderSelectedItems(value)) ||
              (enableTooltip == 'enable' &&
                _.isUndefined(from) &&
                renderSelectedItems(value))
            }
            disableHoverListener={!value}
            open={openToolTip}
          >
            <Select
              onMouseEnter={() => setOpenToolTip(!focusOut ? true : false)}
              onMouseOut={() => setOpenToolTip(false)}
              error={_.isEmpty(errorText) ? false : true}
              helperText={errorText}
              defaultValue={defaultValue}
              name={name}
              size="small"
              value={value}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: { sx: { maxHeight: maxHeight } },
              }}
              onChange={onChange}
              disabled={disabled}
              multiple={multiple}
              renderValue={selected => {
                if (checkBoxSelection) {
                  let i = optionsList
                    ?.filter(item => selected?.includes(item?.code))
                    ?.map(item => item?.display);
                  return i?.join(', ');
                }
                return optionsList?.find(item => item?.code === selected)
                  ?.display;
              }}
              sx={{
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'textFieldColor',
                  borderWidth: 2,
                },
                width: `${width}`,
                '.MuiFormHelperText-root': {
                  fontSize: '14px',
                },
              }}
            >
              {checkBoxSelection
                ? optionsList?.map(item => (
                    <MenuItem
                      disabled={item?.disabled}
                      key={item?.code}
                      value={item?.code}
                      onFocus={() => {
                        setOpenToolTip(false);
                        setFocusOut(true);
                      }}
                      onBlur={() => setFocusOut(false)}
                    >
                      <Checkbox checked={value?.indexOf(item?.code) > -1} />
                      <ListItemText primary={item?.display} />
                    </MenuItem>
                  ))
                : optionsList?.map(item => (
                    <MenuItem
                      disabled={item?.disabled}
                      value={item?.code}
                      onFocus={() => {
                        setOpenToolTip(false);
                        setFocusOut(true);
                      }}
                      onBlur={() => setFocusOut(false)}
                    >
                      {item?.display}
                    </MenuItem>
                  ))}
            </Select>
          </Tooltip>
          <FormHelperText error={_.isEmpty(errorText) ? false : true}>
            {!isEmpty(errorText) ? errorText : ''}
          </FormHelperText>
        </FormControl>
      </>
    );
  }
);

export const SelectWithTopLabelComponentNew = forwardRef(
  (
    {
      label,
      width = '100%',
      value,
      defaultValue = '',
      onChange,
      name,
      optionsList,
      disabled = false,
      validation = {
        required: false,
      },
      checkBoxSelection = false,
      multiple = false,
    } = {},
    ref
  ) => {
    /**
     * @param @optionsList {object array} must be in the form '[{code: code, display: display}]'
     */

    const [errorText, setErrorText] = useState('');

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;
        return { name, value, valid: isValid };
      },
    }));

    return (
      <>
        <FormControl
          sx={{
            width: `${width}`,
            '.MuiFormHelperText-root': {
              fontSize: '14px',
            },
          }}
        >
          <Typography sx={{ fontSize: 14 }}>
            {!_.isEmpty(label) ? `${label}:` : ''}
          </Typography>
          <Select
            error={_.isEmpty(errorText) ? false : true}
            helperText={errorText}
            defaultValue={defaultValue}
            name={name}
            size="small"
            value={value}
            onChange={onChange}
            disabled={disabled}
            multiple={multiple}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              PaperProps: { sx: { maxHeight: '38vh' } },
            }}
            renderValue={selected => {
              if (checkBoxSelection) {
                let i = optionsList
                  ?.filter(item => selected?.includes(item?.code))
                  ?.map(item => item?.display);
                return i?.join(', ');
              }

              return optionsList?.find(item => item?.code === selected)
                ?.display;
            }}
            sx={{
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'textFieldColor',
                borderWidth: 2,
              },
              '.MuiFormHelperText-root': {
                fontSize: '14px',
              },
            }}
          >
            {checkBoxSelection
              ? optionsList?.map(item => (
                  <MenuItem key={item?.code} value={item?.code}>
                    <Checkbox checked={value?.indexOf(item?.display) > -1} />
                    <ListItemText primary={item?.display} />
                  </MenuItem>
                ))
              : optionsList?.map(item => (
                  <MenuItem value={item?.display}>{item?.display}</MenuItem>
                ))}
          </Select>
        </FormControl>
      </>
    );
  }
);

export const DateSelectorWithTopLabelComponentNewFeeschedule = forwardRef(
  (
    {
      name,
      label,
      value,
      format = 'MM/dd/yyyy',
      width = '100%',
      maxCalendarHeight = null,
      onChange,
      placement = 'bottom-start',
      flip = false,
      zIndexModal = 0,
      validation,
    } = {},
    ref
  ) => {
    //let jsDate = dayjs(value)?.format('MM/DD/YYYY');
    let jsDate = dayjs(value)?.toDate();
    const [errorText, setErrorText] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;

        if (validation?.required) {
          if (isNull(value)) {
            isValid = false;
            setErrorText('Date field cannot be empty');
          } else {
            const myDate = new Date(value)?.valueOf();
            if (isNaN(myDate)) {
              isValid = false;
              setErrorText('Date field cannot be invalid');
            } else {
              isValid = true;
              setErrorText('');
            }
          }
        }

        return { name, value, valid: isValid };
      },
    }));

    return (
      <>
        <FormControl
          sx={{
            width: `${width}`,
            '.MuiFormHelperText-root': {
              fontSize: '14px',
            },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              open={isOpen}
              onClose={() => setIsOpen(false)}
              disableFuture={false}
              fullWidth
              inputFormat={format}
              value={jsDate || null}
              onChange={date => {
                let event = {
                  target: {},
                };
                event.target.name = name;
                event.target.value = date;
                onChange(event);
              }}
              PopperProps={{
                placement: placement,
                anchorEl: anchorEl,
                modifiers: [
                  {
                    name: 'flip',
                    enabled: flip,
                    // options: {
                    //   altBoundary: true,
                    //   fallbackPlacements: [
                    //     'top-start',
                    //     'top',
                    //     'top-end',
                    //     'bottom-end',
                    //   ],
                    // },
                  },
                ],
                sx: {
                  '& .css-epd502 ': {
                    height: maxCalendarHeight && maxCalendarHeight,
                  },
                  zIndex: theme => theme.zIndex.modal + zIndexModal,
                },
              }}
              renderInput={params => (
                <Box>
                  <TextField
                    {...params}
                    onClick={event => {
                      setIsOpen(isOpen => !isOpen);
                      setAnchorEl(event.currentTarget);
                    }}
                    error={_.isEmpty(errorText) ? false : true}
                    helperText={errorText}
                    size="small"
                    fullWidth
                    label={label !== undefined ? label : null}
                  />
                </Box>
              )}
            />
          </LocalizationProvider>
        </FormControl>
      </>
    );
  }
);

export const DateSelectorWithTopLabelComponentNew = forwardRef(
  (
    {
      name,
      label,
      value,
      format = 'MM/dd/yyyy',
      width = '100%',
      maxCalendarHeight = null,
      onChange,
      placement = 'bottom-start',
      flip = false,
      zIndexModal = 0,
    } = {},
    ref
  ) => {
    const [selectedDate, setSelectedDate] = useState(dayjs(value).toDate());
    const [errorText, setErrorText] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleDateChange = date => {
      setSelectedDate(date);

      const formattedDate = dayjs(date).format('MM/DD/YYYY');
      onChange({
        target: {
          name: name,
          value: formattedDate,
        },
      });
    };

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;
        return { name, value, valid: isValid };
      },
    }));

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          open={isOpen}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          disableFuture={false}
          fullWidth
          inputFormat={format}
          value={selectedDate}
          onChange={handleDateChange}
          PopperProps={{
            modifiers: [
              {
                name: 'flip',
                enabled: flip,
              },
            ],
            anchorEl: anchorEl,
            placement: placement,
            sx: {
              '& .css-epd502 ': {},
              zIndex: theme => theme.zIndex.modal + zIndexModal,
            },
          }}
          // PopperProps={{
          //   placement: placement,
          //   anchorEl: anchorEl,
          //   modifiers: [
          //     {
          //       name: 'flip',
          //       enabled: flip,
          //       options: {
          //         altBoundary: true,
          //         fallbackPlacements: [
          //           'top-start',
          //           'top',
          //           'top-end',
          //           'bottom-end',
          //         ],
          //       },
          //     },
          //   ],
          //   sx: {
          //     '& .css-epd502 ': {
          //       maxHeight: maxCalendarHeight && maxCalendarHeight,
          //     },
          //   },
          // }}
          renderInput={params => (
            <Box>
              <TextField
                {...params}
                onClick={event => {
                  setIsOpen(!isOpen);
                  setAnchorEl(event.currentTarget);
                }}
                error={!_.isEmpty(errorText)}
                helperText={errorText}
                size="small"
                fullWidth
                label={label !== undefined ? label : null}
              />
            </Box>
          )}
        />
      </LocalizationProvider>
    );
  }
);

export const DateSelectorWithTopLabelComponent = forwardRef(
  (
    {
      name,
      label,
      value,
      format = 'MM/dd/yyyy',
      // format = 'dd/MM/yyyy',
      width = '100%',
      onChange,
      disableFuture = false,
      disablePast = false,
      validation = null,
      maxCalendarHeight = null,
      placement = 'bottom-end',
      flip = false,
      diagnosis,
      zIndexModal = 0,
      disablePortal = true,
      disabled = false,
    } = {},
    ref
  ) => {
    let jsDate = dayjs(value)?.toDate();
    if (!value) {
      jsDate = null;
    }
    const [errorText, setErrorText] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;

        if (validation?.required) {
          if (isNull(value) || value === undefined || value === '') {
            isValid = false;
            setErrorText('Date Field Cannot be Empty');
          } else {
            const myDate = new Date(value)?.valueOf();
            if (isNaN(myDate)) {
              isValid = false;
              setErrorText('Date Field Cannot be Invalid');
            } else if (value?.getFullYear?.() < 1900) {
              isValid = false;
              setErrorText(
                'Invalid date. The date should be in the format MM/DD/YYYY and after 01/01/1900'
              );
            } else {
              isValid = true;
              setErrorText('');
            }
          }
        }

        return { name, value, valid: isValid };
      },
    }));

    return (
      <>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            open={isOpen}
            onClose={() => setIsOpen(false)}
            disableFuture={diagnosis ? true : disableFuture}
            disablePast={disablePast}
            disabled={disabled}
            fullWidth
            inputFormat={format}
            value={jsDate || null}
            onChange={date => {
              let event = {
                target: {},
              };
              event.target.name = name;
              event.target.value = date;
              onChange(event);
            }}
            PopperProps={{
              modifiers: [
                {
                  name: 'flip',
                  enabled: true,
                  options: {
                    altBoundary: true,
                    rootBoundary: 'document',
                    padding: 8,
                  },
                },
                {
                  name: 'preventOverflow',
                  enabled: true,
                  options: {
                    altAxis: true,
                    altBoundary: true,
                    tether: true,
                    rootBoundary: 'document',
                    padding: 8,
                  },
                },
                {
                  name: 'arrow',
                  enabled: false,
                  options: {
                    element: ref,
                  },
                },
              ],
              anchorEl: anchorEl,
              placement: placement,
              disablePortal: disablePortal,
              sx: {
                '& .css-epd502 ': {},
                zIndex: theme => theme.zIndex.modal + zIndexModal,
              },
            }}
            // PopperProps={{
            //   placement: placement,
            //   anchorEl: anchorEl,
            //   modifiers: [
            //     {
            //       name: 'flip',
            //       enabled: flip,
            //       options: {
            //         altBoundary: true,
            //         fallbackPlacements: [
            //           'top-start',
            //           'top',
            //           'top-end',
            //           'bottom-end',
            //         ],
            //       },
            //     },
            //   ],
            //   sx: {
            //     '& .css-epd502 ': {
            //       maxHeight: maxCalendarHeight && maxCalendarHeight,
            //     },
            //   },
            // }}
            renderInput={params => (
              <Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    '@media print': {
                      color: '#000',
                      background: '#fff',
                    },
                  }}
                >
                  {`${label} `}
                  {validation?.required ? (
                    <span style={{ color: red[500] }}>*</span>
                  ) : (
                    ''
                  )}
                </Typography>
                <TextField
                  {...params}
                  onClick={event => {
                    setIsOpen(isOpen => !isOpen);
                    setAnchorEl(event.currentTarget);
                  }}
                  error={_.isEmpty(errorText) ? false : true}
                  helperText={errorText}
                  sx={{
                    width: `${width}`,
                    '& .MuiOutlinedInput-root': {
                      '& > fieldset': {
                        borderColor: 'textFieldColor',
                        borderWidth: 2,
                      },
                      '@media print': {
                        color: '#000',
                        background: '#fff',
                      },
                    },
                    '.MuiFormHelperText-root': {
                      fontSize: '14px',
                      '@media print': {
                        color: '#000',
                      },
                    },
                  }}
                  size="small"
                />
              </Box>
            )}
          />
        </LocalizationProvider>
      </>
    );
  }
);

// export const DateTimeSelectorWithTopLabelComponent = forwardRef(
//   ({ name, value, onChange, label, validation = null } = {}, ref) => {
//     useImperativeHandle(ref, () => {
//       return {};
//     });

//     return (
//       <>
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//           <DesktopDateTimePicker
//             label="Date time"
//             value={value}
//             onChange={() => {}}
//             renderInput={params => <TextField {...params} size="small" />}
//           />
//         </LocalizationProvider>
//       </>
//     );
//   }
// );

export const DateTimeSelectorWithTopLabelComponent = forwardRef(
  (
    {
      name,
      label,
      value,
      format = 'MM/DD/YYYY hh:mm A',
      // format = 'dd/MM/yyyy',
      width = '100%',
      onChange,
      disableFuture = false,
      disablePast = false,
      validation = null,
      maxCalendarHeight = null,
      placement = 'bottom-start',
      flip = false,
      diagnosis,
      zIndexModal = 0,
      disabled = false,
      resetError = false,
    } = {},
    ref
  ) => {
    let jsDate = dayjs(value)?.toDate();
    if (!value) {
      jsDate = null;
    }
    const [errorText, setErrorText] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
      if (resetError) {
        setErrorText('');
      }
    }, [resetError]);

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;

        if (validation?.required) {
          if (!Boolean(value)) {
            isValid = false;
            setErrorText('Date Field Cannot be Empty');
          } else {
            const myDate = new Date(value)?.valueOf();
            if (isNaN(myDate)) {
              isValid = false;
              setErrorText('Please enter valid Date and Time');
            } else if (dayjs(value)?.year() < 1900) {
              isValid = false;
              setErrorText('Please enter valid year');
            } else {
              isValid = true;
              setErrorText('');
            }
          }
        }

        return { name, value, valid: isValid };
      },
    }));

    return (
      <>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDateTimePicker
            open={isOpen}
            onClose={() => setIsOpen(false)}
            disableFuture={diagnosis ? true : disableFuture}
            disablePast={disablePast}
            disabled={disabled}
            fullWidth
            // inputFormat={format}
            value={jsDate || null}
            onChange={date => {
              let event = {
                target: {},
              };
              event.target.name = name;
              event.target.value = date;
              onChange(event);
            }}
            PopperProps={{
              modifiers: [
                {
                  name: 'flip',
                  enabled: flip,
                },
              ],
              anchorEl: anchorEl,
              placement: placement,
              sx: {
                '& .css-epd502 ': {},
                zIndex: theme => theme.zIndex.modal + zIndexModal,
              },
            }}
            // PopperProps={{
            //   placement: placement,
            //   anchorEl: anchorEl,
            //   modifiers: [
            //     {
            //       name: 'flip',
            //       enabled: flip,
            //       options: {
            //         altBoundary: true,
            //         fallbackPlacements: [
            //           'top-start',
            //           'top',
            //           'top-end',
            //           'bottom-end',
            //         ],
            //       },
            //     },
            //   ],
            //   sx: {
            //     '& .css-epd502 ': {
            //       maxHeight: maxCalendarHeight && maxCalendarHeight,
            //     },
            //   },
            // }}
            renderInput={params => (
              <Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    '@media print': {
                      color: '#000',
                      background: '#fff',
                    },
                  }}
                >
                  {`${label} `}
                  {validation?.required ? (
                    <span style={{ color: red[500] }}>*</span>
                  ) : (
                    ''
                  )}
                </Typography>
                <TextField
                  {...params}
                  onClick={event => {
                    setIsOpen(isOpen => !isOpen);
                    setAnchorEl(event.currentTarget);
                  }}
                  error={_.isEmpty(errorText) ? false : true}
                  helperText={errorText}
                  sx={{
                    width: `${width}`,
                    '& .MuiOutlinedInput-root': {
                      '& > fieldset': {
                        borderColor: 'textFieldColor',
                        borderWidth: 2,
                      },
                      '@media print': {
                        color: '#000',
                        background: '#fff',
                      },
                    },
                    '.MuiFormHelperText-root': {
                      fontSize: '14px',
                      '@media print': {
                        color: '#000',
                      },
                    },
                  }}
                  size="small"
                />
              </Box>
            )}
          />
        </LocalizationProvider>
      </>
    );
  }
);

export const CheckboxComponent = forwardRef(
  ({
    disabled = false,
    value = false,
    name,
    onChange,
    title,
    sx,
    position = 0,
    titleFontSize = `14px`,
  } = {}) => {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            ...sx,
          }}
        >
          <Checkbox
            disabled={disabled}
            checked={value}
            name={name}
            sx={{ color: 'textFieldColor' }}
            onChange={event => {
              const { name, checked } = event?.target;
              let customEvent = {
                target: {
                  name,
                  value: checked,
                },
              };
              onChange(customEvent, position);
            }}
          />
          <Typography
            sx={{
              cursor: 'pointer',
              fontSize: `${titleFontSize}`,
              opacity: disabled ? 0.7 : 1,
            }}
          >
            {title}
          </Typography>
        </Box>
      </>
    );
  }
);

export const TimeSelectorWithTopLabelComponent = forwardRef(
  (
    {
      name,
      label,
      value,
      format = '',
      width = '100%',
      onChange,
      disabled = false,
      validation = null,
      minutesStep = 1,
    } = {},
    ref
  ) => {
    console.log(`slot inside`, value);

    const [errorText, setErrorText] = useState(``);
    const [anchorEl, setAnchorEl] = useState(null);

    const isValidTime = (timeString, interval) => {
      if (!timeString) return true;
      const date = dayjs(timeString);
      if (!date.isValid()) {
        return false;
      }
      const minutes = date.minute();
      if (minutes % Number(interval) !== 0) {
        return false;
      }
      return true;
    };

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;
        if (validation?.required) {
          if (isNull(value)) {
            isValid = false;
            setErrorText('Time field cannot be empty');
          } else {
            const myDate = new Date(value)?.valueOf();
            if (isNaN(myDate)) {
              isValid = false;
              setErrorText('Time field cannot be invalid');
            } else {
              isValid = true;
              setErrorText('');
            }
          }
        }

        return { name, value, valid: isValid };
      },
    }));

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimePicker
          fullWidth
          name={name}
          value={value}
          minutesStep={minutesStep}
          disabled={disabled}
          PopperProps={{
            placement: 'bottom-start',
            anchorEl: anchorEl,
            sx: {
              zIndex: theme => theme.zIndex.modal + 2,
            },
          }}
          onChange={(newValue, oldValue) => {
            let event = {
              target: {
                name: name,
                value: newValue,
              },
            };
            if (!isValidTime(newValue, minutesStep)) {
              setErrorText('Invalid time, must be in 15 minute intervals');
              onChange(event);
            } else {
              onChange(event);
              setErrorText('');
            }
          }}
          renderInput={params => (
            <Box>
              <Typography sx={{ fontSize: 14 }}>
                {`${label} `}
                {validation?.required ? (
                  <span style={{ color: red[500] }}>*</span>
                ) : (
                  ''
                )}
              </Typography>
              <TextField
                {...params}
                helperText={errorText}
                error={_.isEmpty(errorText) ? false : true}
                sx={{
                  width: `${width}`,
                  '& .MuiOutlinedInput-root': {
                    '& > fieldset': {
                      borderColor: 'textFieldColor',
                      borderWidth: 2,
                    },
                  },
                  '.MuiFormHelperText-root': {
                    fontSize: '14px',
                  },
                }}
                size="small"
                disabled={disabled}
                onClick={event => {
                  setAnchorEl(event.currentTarget);
                }}
              />
            </Box>
          )}
        />
      </LocalizationProvider>
    );
  }
);

export const AutoCompleteWithTopLabel = forwardRef(
  (
    {
      width = '100%',
      label,
      scrolledValue = {
        scrollAmount: 0,
        minScrollAmount: 0,
      },
      name,
      value,
      onChange,
      onBlur,
      validation,
      optionsList,
      getData,
      dataType,
      multiple = false,
      freeSolo = false,
      disablePortal = false,
      disableClearable = false,
      optionsRender = 'display',
      customErrorText = 'This field cannot be empty',
      getOptionDisabled = false,
      disabled = false,
      onInputValueChange = null,
      from,
      addressState,
      stateForProps,
      setStateForProps,
      of,
      organizationState,
      forOnly,
      relatedpersonState,
      zIndex,
      toolTip,
      isNotZipCode = false,
    } = {},
    ref
  ) => {
    const [errorText, setErrorText] = useState('');
    const [loading, setLoading] = useState(false);
    const autoCompleteRef = useRef(null);
    const [inputValue, setInputValue] = useState('');
    const { isDark } = useMainFrameState();

    useEffect(() => {
      if (_.isEmpty(optionsList)) {
        setLoading(true);
      } else {
        setLoading(false);
      }
    }, [optionsList]);

    let optionsHistory = [];

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;
        if (validation?.required) {
          if (value?.code && !isNotZipCode) {
            if (
              ((!boolState && value?.code?.toString().length < 4) ||
                (boolState && value?.code?.toString().length < 5)) &&
              _.isUndefined(value?.country)
            ) {
              isValid = false;
              setErrorText('5 digits required for Zip Code');
            } else {
              isValid = true;
              setErrorText('');
            }
          } else if (isNotZipCode) {
            if (value?.code) {
              setErrorText('');
              isValid = true;
            } else {
              setErrorText(customErrorText);
              isValid = false;
            }
          } else {
            setErrorText(customErrorText);
            isValid = false;
          }
          if (of == 'ORGANIZATION') {
            if (addressState?.postalCode?.code == '') {
              setErrorText(customErrorText);
              isValid = false;
            } else if (addressState?.postalCode?.code.toString().length < 5) {
              setErrorText('5 digits required for Zip Code');
              isValid = false;
            }
          }
        }

        return { name, value, isValid };
      },
    }));

    const getOptionLabel = option => {
      if (typeof option === 'string') {
        return option;
      }
      return option?.[optionsRender];
    };
    const [open, setOpen] = useState(false);

    useEffect(() => {
      if (
        scrolledValue?.scrollAmount > scrolledValue?.minScrollAmount &&
        open
      ) {
        setOpen(false);
      }
    }, [scrolledValue]);

    const [boolState, setBoolState] = useState(false);
    const [myFocus, setMyFocus] = useState(false);
    const [conditionalState, setConditionalState] = useState(value);
    const [myValueObject, setMyValueObject] = useState({});
    const editSwitch = useSelector(state => {
      return state?.toolbar?.editSwitch;
    });

    useEffect(() => {
      // const OFZipCodes = getZipCodes(addressState?.officialState);
      const OFZipCodes = getZipCodes(
        addressState?.officialState,
        addressState?.officialCountry?.slice(0, 2).toUpperCase()
      );
      const BPZipCodes = getZipCodes(
        addressState?.billingState,
        addressState?.billingCountry?.slice(0, 2).toUpperCase()
      );

      const LPCZipCodes = getZipCodes(
        addressState?.state,
        addressState?.country?.slice(0, 2).toUpperCase()
      );
      const OFZCResponse = OFZipCodes?.find(
        e => e?.display == addressState?.officialPostalCode?.display
      );
      const BPZCResponse = BPZipCodes?.find(
        e => e?.display == addressState?.billingPostalCode?.display
        // e => e?.display ==  value?.display //this is working but need test it thorougly first before implementing it here , use this with eq2 ----> this is eq1
      );
      const LPZCResponse = LPCZipCodes?.find(e => e?.display == value?.display);
      if (editSwitch) {
        if (name == 'officialPostalCode') {
          if (addressState?.officialPostalCode == undefined) {
            setBoolState(true);
          }
        } else if (name == 'billingPostalCode') {
          if (addressState?.billingPostalCode == undefined) {
            if (value?.code == '') {
              setBoolState(false);
            } else {
              setBoolState(true);
            }
          }
        } else if (name == 'postalCode') {
          if (
            addressState?.postalCode == undefined &&
            LPZCResponse == undefined &&
            value == undefined
          ) {
            setBoolState(false);
          } else if (
            addressState?.postalCode == undefined &&
            LPZCResponse == undefined &&
            value?.display == ''
          ) {
            setBoolState(false);
          } else if (
            LPZCResponse == undefined &&
            value != undefined &&
            of !== 'quickAdd'
          ) {
            setBoolState(true);
          }
        }
      } else if (!editSwitch) {
        if (name == 'officialPostalCode') {
          if (
            OFZCResponse == undefined &&
            addressState?.officialPostalCode != undefined
          ) {
            setBoolState(true);
          }
        } else if (name == 'billingPostalCode') {
          if (
            BPZCResponse == undefined &&
            addressState?.billingPostalCode != undefined
          ) {
            setBoolState(true);
          }
        } else if (name == 'postalCode') {
          if (
            addressState?.postalCode != undefined &&
            LPZCResponse == undefined
          ) {
            setBoolState(true);
          }
        }
      }
    }, []);

    useEffect(() => {
      if (name == 'officialPostalCode') {
        if (value?.code == '') {
          setBoolState(false);
          setOpen(false);
        }
      }
    }, [addressState?.officialState]);

    //cc//

    useEffect(() => {
      if (name == 'officialPostalCode') {
        if (addressState?.officialPostalCode == '') {
          setBoolState(false);
          setOpen(false);
        }
      }
    }, [addressState?.officialCountry, addressState]);
    useEffect(() => {
      if (name == 'billingPostalCode') {
        if (addressState?.billingPostalCode == '') {
          setBoolState(false);
          setOpen(false);
        }
      }
    }, [addressState?.billingCountry, addressState]);

    useEffect(() => {
      if (name == 'postalCode') {
        if (addressState?.postalCode?.display == '') {
          setBoolState(false);
          setOpen(false);
        }
      }
    }, [addressState?.country, addressState]);

    useEffect(() => {
      if (name == 'billingPostalCode') {
        if (value?.code == '') {
          setBoolState(false);
          setOpen(false);
        }
      }
    }, [addressState?.billingState]);

    // useEffect(() => {
    //   if (name == 'officialPostalCode') {
    //     setBoolState(false);
    //   }
    // }, [addressState?.officialState]);

    // useEffect(() => {
    //   if (name == 'billingPostalCode') {
    //     setBoolState(false);
    //   }
    // }, [addressState?.billingState]);

    useEffect(() => {
      const LPCZipCodes = getZipCodes(
        addressState?.state,
        addressState?.country?.slice(0, 2).toUpperCase()
      );
      const LPZCResponse = LPCZipCodes?.find(e => e?.display == value?.display);
      if (of == 'ORGANIZATION') {
        if (editSwitch) {
          if (name == 'postalCode') {
            if (
              addressState?.postalCode?.code != '' &&
              LPZCResponse == undefined
            ) {
              setBoolState(true);
            } else {
              setBoolState(false);
              setOpen(false);
            }
          }
        } else if (!editSwitch) {
          if (name == 'postalCode') {
            if (
              addressState?.postalCode?.code == '' &&
              LPZCResponse == undefined
            ) {
              setBoolState(false);
              setOpen(false);
            } else if (
              addressState?.postalCode?.code == '' &&
              value?.code == '' &&
              LPZCResponse == undefined
            ) {
              setBoolState(false);
              // setOpen(false)
            }
          }
        }
      }
    }, [addressState?.state]);

    useEffect(() => {
      if (of == 'ORGANIZATION') {
        if (name == 'postalCode') {
          if (addressState?.postalCode?.code == '') {
            setStateForProps(true);
          } else if (addressState?.postalCode?.code != '') {
            setStateForProps(false);
          }
        }
      }
    }, [value, addressState?.state, addressState?.postalCode]);

    useEffect(() => {
      if (forOnly == 'fhirOrganizationQuickAdd') {
        if (name == 'postalCode') {
          setBoolState(false);
          onChange({
            target: {
              name: 'postalCode',
              value: { code: '', display: '' },
            },
          });
          setOpen(false);
        }
      }
    }, [organizationState?.state, organizationState?.country]);

    useEffect(() => {
      if (name == 'postalCode') {
        if (
          relatedpersonState?.relationship?.code != '' &&
          relatedpersonState != undefined
        ) {
          const LPCZipCodes = getZipCodes(
            relatedpersonState?.state?.code
              ? relatedpersonState?.state?.code
              : 'AL',
            relatedpersonState?.country
          );
          const LPZCResponse = LPCZipCodes?.find(
            e => e?.display == value?.display
          );

          if (relatedpersonState?.state != undefined) {
            if (relatedpersonState?.postalCode?.code == '') {
              setBoolState(false);
              setOpen(false);
            } else if (LPZCResponse == undefined) {
              setBoolState(true);
            } else if (LPZCResponse != undefined) {
              setBoolState(false);
            }
          } else if (LPZCResponse != undefined) {
            setBoolState(false);
          }
        }
      }
    }, [relatedpersonState?.state?.code, relatedpersonState?.postalCode]);

    return (
      <Box sx={{ width: `${width}` }}>
        <Typography sx={{ fontSize: 14, visibility: myFocus && 'hidden' }}>
          {`${label} `}
          {validation?.required ? (
            <span style={{ color: red[500] }}>*</span>
          ) : (
            ''
          )}
        </Typography>

        {!boolState ? (
          <Tooltip
            title={
              !_.isUndefined(toolTip) &&
              (toolTip == 'forOrganization'
                ? value?.display?.length > 37 && value?.display
                : toolTip == 'forAllergy'
                ? value?.length > 0 &&
                  value?.map(e => (
                    <Typography fontSize={'11px'}>{e?.display}</Typography>
                  ))
                : toolTip == 'forImmunization' && value?.display?.length > 30
                ? value?.display
                : toolTip == 'race' && value?.display)
            }
            disableInteractive
          >
            <Autocomplete
              key={name}
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              slotProps={{
                popper: {
                  sx: {
                    zIndex: zIndex ? zIndex : '',
                  },
                },
              }}
              noOptionsText={
                from == 'practitionerCreate' ? (
                  <Box>
                    <Typography>No Zip code found</Typography>
                    <Button
                      sx={{ marginLeft: -1 }}
                      onClick={() => {
                        setBoolState(true);
                        setTimeout(() => {
                          let newEvent = {
                            target: {
                              name: name,
                              // value: {
                              //   code: inputValue.slice(0, 5),
                              //   display: inputValue.slice(0, 5),
                              // },
                              value: {
                                code: inputValue.slice(
                                  0,
                                  name == 'officialPostalCode'
                                    ? // ? addressState?.officialCountry == 'IN'
                                      addressState?.officialCountry?.toLowerCase() ==
                                      'in'
                                      ? 6
                                      : 5
                                    : name == 'billingPostalCode'
                                    ? // ? addressState?.billingCountry == 'IN'
                                      addressState?.billingCountry?.toLowerCase() ==
                                      'in'
                                      ? 6
                                      : 5
                                    : name == 'postalCode' &&
                                      !_.isUndefined(addressState)
                                    ? // ? addressState?.country == 'IN'
                                      addressState?.country?.toLowerCase() ==
                                      'in'
                                      ? 6
                                      : 5
                                    : name == 'postalCode' &&
                                      !_.isUndefined(relatedpersonState)
                                    ? relatedpersonState?.country == 'IN'
                                      ? 6
                                      : 5
                                    : name == 'postalCode' &&
                                      !_.isUndefined(organizationState)
                                    ? organizationState?.country == 'IN'
                                      ? 6
                                      : 5
                                    : 5
                                ),

                                display: inputValue.slice(
                                  0,
                                  name == 'officialPostalCode'
                                    ? // ? addressState?.officialCountry == 'IN'
                                      addressState?.officialCountry?.toLowerCase() ==
                                      'in'
                                      ? 6
                                      : 5
                                    : name == 'billingPostalCode'
                                    ? // ? addressState?.billingCountry == 'IN'
                                      addressState?.billingCountry?.toLowerCase() ==
                                      'in'
                                      ? 6
                                      : 5
                                    : name == 'postalCode' &&
                                      !_.isUndefined(addressState)
                                    ? // ? addressState?.country == 'IN'
                                      addressState?.country?.toLowerCase() ==
                                      'in'
                                      ? 6
                                      : 5
                                    : name == 'postalCode' &&
                                      !_.isUndefined(relatedpersonState)
                                    ? relatedpersonState?.country == 'IN'
                                      ? 6
                                      : 5
                                    : name == 'postalCode' &&
                                      !_.isUndefined(organizationState)
                                    ? organizationState?.country == 'IN'
                                      ? 6
                                      : 5
                                    : 5
                                ),
                              },
                            },
                          };
                          onChange(newEvent);
                        }, 200);
                      }}
                    >
                      Enter ZIP Code Manually
                    </Button>
                  </Box>
                ) : name == 'doctorObject' ? (
                  'No Doctors Found'
                ) : (
                  'No Options'
                )
              }
              freeSolo={freeSolo}
              isOptionEqualToValue={
                multiple
                  ? undefined
                  : (option, value) => option?.code !== value?.code
              }
              ref={autoCompleteRef}
              disabled={disabled}
              disablePortal={disablePortal}
              disableClearable={disableClearable}
              multiple={multiple}
              filterSelectedOptions={multiple}
              size="small"
              sx={{ width: `${width}` }}
              name={name}
              // value={value}
              value={
                name == 'postalCode' ? (stateForProps ? '' : value) : value
              }
              inputValue={inputValue}
              options={optionsList}
              getOptionDisabled={getOptionDisabled}
              getOptionSelected={
                multiple
                  ? undefined
                  : (option, value) => option?.display === value?.display
              }
              getOptionLabel={option =>
                typeof option === 'string' ? option : option?.[optionsRender]
              }
              renderOption={(props, option, state) => {
                const isSelected = multiple
                  ? state?.selected
                  : (option?.code === value?.code || !option?.code) &&
                    isEqual(value, option);

                const backgroundColor = isSelected
                  ? isDark
                    ? '#536271'
                    : '#EFF5F8'
                  : 'inherit';

                return (
                  <li
                    {...props}
                    style={{
                      backgroundColor,
                    }}
                  >
                    {getOptionLabel(option)}
                  </li>
                );
              }}
              // filterOptions={(options, { inputValue }) => {
              //   let retVal = options?.filter(option => {
              //     return option?.[optionsRender]
              //       ?.toLowerCase()
              //       ?.includes(inputValue?.toLowerCase());
              //   });
              //   return retVal;
              // }}
              onChange={(event, newValue) => {
                let newEvent = {
                  target: {
                    name: name,
                    value: newValue,
                  },
                };
                if (name == 'officialPostalCode') {
                  setBoolState(false);
                }
                if (name == 'billingPostalCode') {
                  setBoolState(false);
                }
                onChange(newEvent);
              }}
              // onBlur={event => {
              //   console.log(event);
              //   if (label === 'Suffix') {
              //     const enterKeyEvent = document.createEvent('Event');
              //     enterKeyEvent.initEvent('keydown', true, true);
              //     enterKeyEvent.key = 'Enter';
              //     enterKeyEvent.keyCode = 13;

              // //     autoCompleteRef.current.dispatchEvent(enterKeyEvent);
              // //   }
              // // }}
              onBlur={(event, newValue) => {
                if (!_.isUndefined(onBlur)) {
                  let newEvent = {
                    target: {
                      value: event?.target?.value,
                    },
                  };
                  if (multiple) {
                    setInputValue('');
                  }
                  onBlur(newEvent);
                }
              }}
              // onBlur={(event, newValue) => {
              //   let newEvent = {
              //     target: {
              //       value: event?.target?.value,
              //     },
              //   };
              //   onBlur(newEvent);
              // }}
              onInputChange={(event, newValue, reason) => {
                if (from == 'practitionerCreate' && newValue) {
                  newValue = newValue.match(/\d/g);
                  newValue = newValue ? newValue.join('') : '';
                }
                let newEvent = {
                  target: {
                    name: name,
                    value: {
                      code: newValue,
                      display: newValue,
                    },
                  },
                };

                if (onInputValueChange) {
                  onInputValueChange(newEvent);
                }
                if (newValue && getData && dataType) {
                  getData(dataType, newValue);
                }
                setInputValue(newValue);
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& > fieldset': {
                        borderColor: 'textFieldColor',
                        borderWidth: 2,
                      },
                    },
                    '.MuiFormHelperText-root': {
                      fontSize: '14px',
                    },
                  }}
                  size="small"
                  error={_.isEmpty(errorText) ? false : true}
                  helperText={errorText}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: <>{params.InputProps.endAdornment}</>,
                  }}
                />
              )}
            />
          </Tooltip>
        ) : (
          <TextField
            size="small"
            label={myFocus ? 'Enter Zip Code Here' : ''}
            name={name}
            value={value?.display}
            sx={{
              width: `${width}`,
              '& .MuiOutlinedInput-root': {
                '& > fieldset': {
                  borderColor: 'textFieldColor',
                  borderWidth: 2,
                },
              },
              '.MuiFormHelperText-root': {
                fontSize: '14px',
              },
            }}
            onFocus={() => setMyFocus(true)}
            onBlur={() => setMyFocus(false)}
            onChange={(event, newValue) => {
              let newEvent = {
                target: {
                  name: name,
                  value: {
                    code: event?.target?.value ? event?.target?.value : ' ',
                    display: event?.target?.value ? event?.target?.value : ' ',
                  },
                },
              };
              onChange(newEvent);
            }}
            error={_.isEmpty(errorText) ? false : true}
            helperText={errorText}
            InputProps={{
              inputComponent: InputMask,
              inputProps: {
                mask:
                  name == 'officialPostalCode'
                    ? // ? addressState?.officialCountry == 'IN'
                      addressState?.officialCountry?.toLowerCase() == 'in'
                      ? '999999'
                      : '99999'
                    : name == 'billingPostalCode'
                    ? // ? addressState?.billingCountry == 'IN'
                      addressState?.billingCountry?.toLowerCase() == 'in'
                      ? '999999'
                      : '99999'
                    : name == 'postalCode' && !_.isUndefined(addressState)
                    ? // ? addressState?.country == 'IN'
                      addressState?.country?.toLowerCase() == 'in'
                      ? '999999'
                      : '99999'
                    : name == 'postalCode' && !_.isUndefined(relatedpersonState)
                    ? relatedpersonState?.country == 'IN'
                      ? '999999'
                      : '99999'
                    : name == 'postalCode' && !_.isUndefined(organizationState)
                    ? organizationState?.country == 'IN'
                      ? '999999'
                      : '99999'
                    : '99999',
                maskChar: '',
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    title="Select list"
                    onClick={() => {
                      setBoolState(false);
                      onChange({
                        target: {
                          name: name,
                          value: {
                            code: '',
                            display: '',
                          },
                        },
                      });
                      setOpen(false);
                    }}
                    edge="end"
                    aria-label="icon"
                  >
                    <FlipCameraAndroidIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      </Box>
    );
  }
);

const initialUrlState = { loadTimeURL: '' };

function localReducer(state, action) {
  switch (action.type) {
    case 'setUrl': {
      return { loadTimeURL: action?.payloadUrl };
    }
    default:
      return {};
  }
}

export const AsyncAutoCompleteWithTopLabel = forwardRef(
  (
    {
      width = '100%',
      scrolledValue = {
        scrollAmount: 0,
        minScrollAmount: 0,
      },
      label,
      name,
      value,
      onChange,
      validation,
      disableClearable = false,
      multiple = false,
      url = '',
      bundlingFunction = null,
      disabled = false,
      urlType = '',
      minInput = 1,
      noOptionstype = '',
      noOptionsdrawer = null,
      noOptionstext = '',
      zIndex,
      callback = new Function(),
      searchAll = false,
      placeholder = false,
      setInputValueEmpty = 0,
    } = {},
    ref
  ) => {
    const [errorText, setErrorText] = useState('');
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [state, localDispatch] = useReducer(localReducer, initialUrlState);
    const [noOptionsState, setNoOptionsState] = useState(false);
    const reduxDispatch = useDispatch();
    const tenantOrganizationResource = useSelector(
      state => state?.current?.tenantOrganization
    );
    // const compRef = useRef(null);
    const {
      display: quickAddDisplay,
      code: quickAddCode,
      label: quickAddLabel,
      value: quickAddValue,
      raw: quickAddRaw,
      componentName: quickAddComponentName,
    } = useSelector(state => state.quickAddData);

    useEffect(() => {
      if (
        quickAddDisplay ||
        quickAddCode ||
        quickAddLabel ||
        quickAddValue ||
        quickAddRaw
      ) {
        let newEvent = {
          target: {
            name: quickAddComponentName,
            value: {
              display: quickAddDisplay,
              code: quickAddCode,
              label: quickAddLabel,
              value: quickAddValue,
              raw: quickAddRaw,
            },
          },
        };
        onChange(newEvent);
        reduxDispatch(
          quickAddData({
            code: '',
            display: '',
            value: '',
            label: '',
            raw: '',
          })
        );
      }
    }, [
      quickAddDisplay,
      quickAddCode,
      quickAddLabel,
      quickAddValue,
      quickAddRaw,
    ]);

    let active = true;

    useEffect(() => {
      if (setInputValueEmpty) {
        setInputValue('');
      }
    }, [setInputValueEmpty]);

    useEffect(() => {
      if (state?.loadTimeURL === '') {
        localDispatch({ type: 'setUrl', payloadUrl: url });
      }

      if (state?.loadTimeURL !== '') {
        if (state?.loadTimeURL !== url) {
          setOptions([]);
          setInputValue('');
          localDispatch({ type: 'setUrl', payloadUrl: url });
          let newEvent = {
            target: {
              name: name,
              value: null,
            },
          };
          onChange(newEvent);
        }
      }
    }, [url, state?.loadTimeURL]);

    useEffect(() => {
      console.log(`OPX`, value, inputValue, options);
    }, [options, value, inputValue]);

    const [open, setOpen] = useState(false);

    useEffect(() => {
      if (
        scrolledValue?.scrollAmount > scrolledValue?.minScrollAmount &&
        open
      ) {
        setOpen(false);
      }
    }, [scrolledValue]);

    const searchData = async inputValue => {
      setLoading(true);
      try {
        let response = null;
        if (urlType === 'fhir') {
          if (searchAll) {
            if (isEmpty(inputValue)) {
              let filterToRemoveVirtualLocation = `type:not=http://enliv.com/location/type|enliv-internal-virtual-location`;
              response = await ehrAPIBaseService.get(
                `fhir/search/Location?${filterToRemoveVirtualLocation}&organization=${tenantOrganizationResource?.id}`
              );
            } else {
              response = await ehrAPIBaseService.get(url + inputValue);
            }
          } else {
            response = await ehrAPIBaseService.get(url + inputValue);
          }
        } else {
          response = await axios.get(url + inputValue, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
              'Content-type': 'application/json',
              'x-enliv-tenant-id': jwtDecode(localStorage.getItem('jwtToken'))
                ?.firebase?.tenant,
            },
          });
        }

        const optionsList = bundlingFunction(response?.data?.entry);
        if (_.isUndefined(optionsList) || optionsList.length === 0) {
          setNoOptionsState(false);
        } else {
          setNoOptionsState(true);
        }
        console.log(`optionsList`, optionsList);

        if (active) {
          setOptions(optionsList);
          setLoading(false);
        }
      } catch (e) {
        console.error(`Autocomplete Async error`, e);
      } finally {
        setLoading(false);
      }
    };

    useImperativeHandle(ref, () => ({
      onValidate() {
        // debugger;
        let isValid = true;
        if (validation?.required) {
          if (value) {
            isValid = true;
            setErrorText('');
          } else {
            setErrorText('This field cannot be empty');
            isValid = false;
          }
          if (typeof value === 'object') {
            if (value?.code || value?.value || value?.reference) {
              isValid = true;
              setErrorText('');
            } else {
              isValid = false;
              setErrorText('This field cannot be empty');
            }
          }
        }

        return { name, value, isValid };
      },
    }));

    let delayedSearch = debounce(searchData, 300);

    const handleOnFocus = () => {
      if (isEmpty(inputValue)) {
        if (searchAll) {
          delayedSearch('');
        } else {
          delayedSearch(`a`);
        }
      }
    };

    return (
      <Box sx={{ width: `${width}` }} key={value?.code}>
        <Typography sx={{ fontSize: 14 }}>
          {!_.isEmpty(label) && `${label} `}
          {validation?.required && <span style={{ color: red[500] }}>*</span>}
        </Typography>
        <Tooltip
          title={value?.display && value?.display.length > 21 && value?.display}
        >
          <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onFocus={handleOnFocus}
            key={url}
            disableClearable={disableClearable}
            disabled={disabled}
            multiple={multiple}
            filterSelectedOptions={multiple}
            size="small"
            sx={{ width: `${width}` }}
            slotProps={{
              popper: {
                sx: {
                  zIndex: zIndex ? zIndex : '',
                },
              },
            }}
            name={name}
            value={value}
            noOptionsText={
              <NoOptions
                type={noOptionstype}
                onClick={noOptionsdrawer}
                text={noOptionstext}
                name={name}
              />
            }
            options={options}
            loading={loading}
            getOptionLabel={option => {
              return option?.display;
            }}
            onChange={(event, newValue) => {
              let newEvent = {
                target: {
                  name: name,
                  value: newValue,
                },
              };
              onChange(newEvent);
            }}
            onInputChange={(event, newValue) => {
              setInputValue(newValue);
              if (!isEmpty(newValue)) {
                setInputValue(newValue);
                setOptions([]);
                delayedSearch(newValue);
              } else {
                setOptions([]);
                // delayedSearch('a');
                if (searchAll) {
                  delayedSearch('');
                } else {
                  delayedSearch(`a`);
                }
              }
              setLoading(false);
            }}
            renderInput={params => (
              <TextField
                {...params}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& > fieldset': {
                      borderColor: 'textFieldColor',
                      borderWidth: 2,
                    },
                  },
                  '.MuiFormHelperText-root': {
                    fontSize: '14px',
                  },
                }}
                size="small"
                placeholder={placeholder || `Search ${label}`}
                error={_.isEmpty(errorText) ? false : true}
                helperText={errorText}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={15} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Tooltip>
      </Box>
    );
  }
);

export const AsyncAutoCompleteWithTopLabelNew1 = forwardRef(
  (
    {
      width = '100%',
      label,
      name,
      value,
      onChange,
      validation,
      multiple = false,
      url = '',
      bundlingFunction = null,
      disabled = false,
      urlType = '',
      minInput = 1,
      noOptionstype = '',
      noOptionsdrawer = null,
      noOptionstext = '',
      zIndex,
    } = {},
    ref
  ) => {
    const [errorText, setErrorText] = useState('');
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [state, localDispatch] = useReducer(localReducer, initialUrlState);
    const [noOptionsState, setNoOptionsState] = useState(false);
    const reduxDispatch = useDispatch();

    const {
      display: quickAddDisplay,
      code: quickAddCode,
      label: quickAddLabel,
      value: quickAddValue,
      raw: quickAddRaw,
      componentName: quickAddComponentName,
    } = useSelector(state => state.quickAddData);

    useEffect(() => {
      if (
        quickAddDisplay ||
        quickAddCode ||
        quickAddLabel ||
        quickAddValue ||
        quickAddRaw
      ) {
        let newEvent = {
          target: {
            name: quickAddComponentName,
            value: {
              display: quickAddDisplay,
              code: quickAddCode,
              label: quickAddLabel,
              value: quickAddValue,
              raw: quickAddRaw,
            },
          },
        };
        onChange(newEvent);
        reduxDispatch(
          quickAddData({
            code: '',
            display: '',
            value: '',
            label: '',
            raw: '',
          })
        );
      }
    }, [
      quickAddDisplay,
      quickAddCode,
      quickAddLabel,
      quickAddValue,
      quickAddRaw,
    ]);

    let active = true;

    useEffect(() => {
      if (state?.loadTimeURL === '') {
        localDispatch({ type: 'setUrl', payloadUrl: url });
      }

      if (state?.loadTimeURL !== '') {
        if (state?.loadTimeURL !== url) {
          setOptions([]);
          localDispatch({ type: 'setUrl', payloadUrl: url });
          let newEvent = {
            target: {
              name: name,
              value: null,
            },
          };
          onChange(newEvent);
        }
      }
    }, [url, state?.loadTimeURL]);

    useEffect(() => {
      console.log(`OPX`, value, inputValue, options);
    }, [options, value, inputValue]);

    // Fetch initial data when component mounts
    // useEffect(() => {
    //   searchData('a');
    // }, []);

    const searchData = async inputValue => {
      setLoading(true);
      // Clear the options at the start of new search
      setOptions([]);
      try {
        let response = null;
        if (urlType === 'fhir') {
          response = await ehrAPIBaseService.get(url + inputValue);
        } else {
          response = await axios.get(url + inputValue, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
              'Content-type': 'application/json',
              'x-enliv-tenant-id': jwtDecode(localStorage.getItem('jwtToken'))
                .firebase.tenant,
            },
          });
        }

        const optionsList = bundlingFunction(response?.data?.entry);
        console.log(`optionsList`, optionsList);

        if (active) {
          setOptions(optionsList);
        }
      } catch (e) {
        console.error(`Autocomplete Async error`, e);
      } finally {
        setLoading(false);
      }
    };

    const searchDataDelayed = debounce(searchData, 500);

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;
        if (validation?.required) {
          if (value) {
            isValid = true;
            setErrorText('');
          } else {
            setErrorText('This field cannot be empty');
            isValid = false;
          }
          if (typeof value === 'object') {
            if (value?.code || value?.value || value?.reference) {
              isValid = true;
              setErrorText('');
            } else {
              isValid = false;
              setErrorText('This field cannot be empty');
            }
          }
        }

        return { name, value, isValid };
      },
    }));

    return (
      <Box sx={{ width: `${width}` }}>
        <Typography sx={{ fontSize: 14 }}>
          {!_.isEmpty(label) && `${label} `}
          {validation?.required && <span style={{ color: red[500] }}>*</span>}
        </Typography>
        <Tooltip
          title={value?.display && value?.display.length > 21 && value?.display}
        >
          <Autocomplete
            key={url}
            disabled={disabled}
            multiple={multiple}
            filterSelectedOptions={multiple}
            size="small"
            sx={{ width: `${width}` }}
            slotProps={{
              popper: {
                sx: {
                  zIndex: zIndex ? zIndex : '',
                },
              },
            }}
            name={name}
            value={value}
            noOptionsText={
              <NoOptions
                type={noOptionstype}
                onClick={noOptionsdrawer}
                text={noOptionstext}
                name={name}
              />
            }
            options={options}
            loading={loading}
            getOptionLabel={option => {
              return option?.display;
            }}
            onChange={(event, newValue) => {
              let newEvent = {
                target: {
                  name: name,
                  value: newValue,
                },
              };
              onChange(newEvent);
            }}
            onInputChange={(event, newValue) => {
              setInputValue(newValue);
              if (!isEmpty(newValue)) {
                // Clear previous options before new search
                setOptions([]);
                searchData(newValue);
              }
              setLoading(false);
            }}
            renderInput={params => (
              <TextField
                {...params}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& > fieldset': {
                      borderColor: 'textFieldColor',
                      borderWidth: 2,
                    },
                  },
                  '.MuiFormHelperText-root': {
                    fontSize: '14px',
                  },
                }}
                size="small"
                placeholder={`Search  ${label}`}
                error={_.isEmpty(errorText) ? false : true}
                helperText={errorText}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={15} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Tooltip>
      </Box>
    );
  }
);

export const AsyncAutoCompleteWithTopLabelNew = forwardRef(
  (
    {
      width = '100%',
      label,
      name,
      value,
      onChange,
      validation,
      multiple = false,
      url = '',
      bundlingFunction = null,
      disabled = false,
      urlType = '',
      passNoHeaders = false,
      onBlur = () => {},
      display,
    } = {},
    ref
  ) => {
    const [errorText, setErrorText] = useState('');
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
      let active = true;
      //if (!loading) return undefined;
      (async () => {
        try {
          if (inputValue?.length < 3) {
            //setLoading(false);
            return false;
          }
          let response = null;
          if (urlType === 'fhir') {
            response = await ehrAPIBaseService.get(url + inputValue);
          } else {
            const headers = !passNoHeaders
              ? {
                  Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
                  'Content-type': 'application/json',
                }
              : {};
            response = await axios.get(url + inputValue, {
              headers,
            });
          }

          let bundle = null;
          if (urlType === 'fhir') {
            bundle = response?.data?.entry;
          } else {
            bundle = response?.data;
          }

          const optionsList = bundlingFunction(bundle);
          console.log(`optionsList`, optionsList);

          if (active) {
            setOptions(optionsList);
            setLoading(false);
          }
        } catch (e) {
          console.error(`Autocomplete Async error`, e);
        } finally {
          setLoading(false);
        }
      })();

      return () => {
        active = false;
      };
    }, [inputValue, loading]);

    useImperativeHandle(ref, () => ({
      onValidate() {
        let isValid = true;
        if (validation?.required) {
          if (value) {
            isValid = true;
            setErrorText('');
          } else {
            setErrorText('Requested Order field cannot be empty');
            isValid = false;
          }
        }

        return { name, value, isValid };
      },
    }));

    return (
      <Box sx={{ width: `${width}` }}>
        <Typography sx={{ fontSize: 14 }}>
          {!_.isEmpty(label) && `${label} `}
          {validation?.required && <span style={{ color: red[500] }}>*</span>}
        </Typography>
        <Tooltip title={value?.length > 26 && value} disableInteractive>
          <Autocomplete
            noOptionsText={
              inputValue < 3 ? (
                <span className="error-indicator">min 3 chars</span>
              ) : (
                'No Options'
              )
            }
            disabled={disabled}
            multiple={multiple}
            filterSelectedOptions={multiple}
            size="small"
            sx={{ width: `${width}` }}
            name={name}
            value={value}
            options={options}
            loading={loading}
            getOptionLabel={option => {
              console.log('options ', option);
              return option?.display === undefined ? value : option?.display;
            }}
            onBlur={() => {
              onBlur(inputValue);
              setInputValue('');
            }}
            onChange={(event, newValue) => {
              console.log('new value ', newValue);
              if (newValue !== null) {
                let newEvent = {
                  target: {
                    name: name,
                    value: newValue.code,
                    display: newValue.display,
                  },
                };
                onChange(newEvent);
              } else {
                let newEvent = {
                  target: {
                    name: name,
                    value: '',
                    display: '',
                  },
                };
                onChange(newEvent);
              }
            }}
            onInputChange={(event, newValue) => {
              newValue = newValue?.trim();
              if (newValue === '') {
                setInputValue('');
                setOptions([]);
              } else {
                setInputValue(newValue);
                setLoading(true);
              }
            }}
            onBlurCapture={() => setOptions([])}
            renderInput={params => (
              <TextField
                {...params}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& > fieldset': {
                      borderColor: 'textFieldColor',
                      borderWidth: 2,
                    },
                  },
                  '.MuiFormHelperText-root': {
                    fontSize: '14px',
                  },
                }}
                size="small"
                error={_.isEmpty(errorText) ? false : true}
                helperText={errorText}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={15} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Tooltip>
      </Box>
    );
  }
);
